import React from 'react';
import { Calendar, MapPin, Tag } from 'lucide-react';

const events = [
	{
		id: 1,
		title: 'Corporate Anniversary Celebration',
		image: 'https://source.unsplash.com/random/600x400/?corporate,celebration',
		date: 'October 15, 2025',
		location: 'Grand Ballroom, Los Angeles',
		category: 'Corporate',
		description:
			'A sophisticated celebration marking 10 years of business excellence with dinner, awards, and entertainment.',
	},
	{
		id: 2,
		title: 'Summer Wedding Package',
		image: 'https://source.unsplash.com/random/600x400/?wedding,summer',
		date: 'July - September 2025',
		location: 'Various Venues',
		category: 'Wedding',
		description:
			'All-inclusive summer wedding packages with outdoor ceremony options, floral arrangements, and catering.',
	},
	{
		id: 3,
		title: 'Product Launch Gala',
		image: 'https://source.unsplash.com/random/600x400/?product,launch',
		date: 'August 24, 2025',
		location: 'Innovation Center, San Francisco',
		category: 'Corporate',
		description:
			'Exclusive product launch event featuring demonstrations, networking, and media opportunities.',
	},
	{
		id: 4,
		title: 'Charity Fundraiser Dinner',
		image: 'https://source.unsplash.com/random/600x400/?charity,gala',
		date: 'September 10, 2025',
		location: 'City View at Metreon, San Francisco',
		category: 'Non-profit',
		description:
			'Annual fundraising gala with silent auction, live entertainment, and gourmet dining experience.',
	},
	{
		id: 5,
		title: 'Sweet Sixteen Party Package',
		image: 'https://source.unsplash.com/random/600x400/?birthday,celebration',
		date: 'Available Year-round',
		location: 'Custom Venues',
		category: 'Social',
		description:
			'Customizable Sweet Sixteen celebration packages including venue styling, entertainment, and catering.',
	},
	{
		id: 6,
		title: 'Tech Conference 2025',
		image: 'https://source.unsplash.com/random/600x400/?tech,conference',
		date: 'November 5-7, 2025',
		location: 'Convention Center, San Jose',
		category: 'Corporate',
		description:
			'Three-day industry conference with keynote speakers, breakout sessions, and networking opportunities.',
	},
];

export default function Events() {
	return (
		<div className="w-full px-2 sm:px-4 md:px-12 xl:px-32 py-8">
			{/* Page Header */}
			<section className="mb-12 bg-primary/10 rounded-xl p-6 md:p-10 text-white">
				<h1 className="text-3xl md:text-5xl font-bold mb-4 text-primary">
					Our Events
				</h1>
				<p className="text-lg md:text-xl text-primary-foreground">
					Browse our upcoming events and packages that we offer. From corporate
					gatherings to personal celebrations, we create memorable experiences
					tailored to your needs.
				</p>
			</section>

			{/* Events Grid */}
			<section className="mb-12">
				<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
					{events.map((event) => (
						<div
							key={event.id}
							className="bg-white rounded-xl shadow flex flex-col overflow-hidden"
						>
							<img
								src={event.image}
								alt={event.title}
								className="w-full h-48 object-cover"
							/>
							<div className="p-6 flex-1 flex flex-col">
								<div className="flex items-center gap-2 mb-2">
									<Tag className="w-4 h-4 text-primary" />
									<span className="text-xs font-semibold text-primary">
										{event.category}
									</span>
								</div>
								<h3 className="text-lg font-semibold mb-2 text-primary-foreground">
									{event.title}
								</h3>
								<div className="flex items-center gap-2 text-gray-500 text-xs mb-1">
									<Calendar className="w-4 h-4" />
									<span>{event.date}</span>
								</div>
								<div className="flex items-center gap-2 text-gray-500 text-xs mb-2">
									<MapPin className="w-4 h-4" />
									<span>{event.location}</span>
								</div>
								<p className="text-gray-600 text-sm flex-1 mb-4">
									{event.description}
								</p>
								<div className="flex gap-2 mt-auto">
									<button className="bg-primary text-white px-4 py-2 rounded font-semibold hover:bg-primary/90 transition">
										Learn More
									</button>
									<button className="bg-primary/10 text-primary px-4 py-2 rounded font-semibold hover:bg-primary/20 transition">
										Book Now
									</button>
								</div>
							</div>
						</div>
					))}
				</div>
			</section>

			{/* Custom Event CTA */}
			<section className="mt-12 text-center bg-secondary/10 rounded-xl p-8">
				<h2 className="text-2xl md:text-3xl font-bold mb-4 text-secondary">
					Don't see what you're looking for?
				</h2>
				<p className="mb-6 text-base md:text-lg">
					We specialize in creating custom events tailored to your specific needs
					and vision. Contact us today to discuss how we can help make your dream
					event a reality.
				</p>
				<button className="bg-secondary text-white px-6 py-3 rounded font-semibold hover:bg-secondary/90 transition">
					Request Custom Event
				</button>
			</section>
		</div>
	);
}
